module.exports = __webpack_public_path__ + "static/media/verified.7a8fe0db.png";